import { render, staticRenderFns } from "./IconFaceFrown.vue?vue&type=template&id=9d4e7570&"
import script from "./IconFaceFrown.vue?vue&type=script&lang=js&"
export * from "./IconFaceFrown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports